import React from 'react';
import ReactPaginate from 'react-paginate';
import styles from './pagination.module.scss';

const DEFAULT_LIMIT_OPTIONS = [10, 20, 50, 100];

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  const main = document.querySelector('main');
  if (main) {
    main.scrollTo({ top: 0, behavior: 'smooth' });
  }
};

const Pagination = ({
  page,
  limit,
  count,
  onPageChange,
  onLimitChange,
  limitOptions = DEFAULT_LIMIT_OPTIONS,
}) => {
  const pageCount = Math.max(1, Math.ceil(count / limit));
  const start = count === 0 ? 0 : page * limit + 1;
  const end = count === 0 ? 0 : Math.min((page + 1) * limit, count);

  const handlePageChange = (data) => {
    onPageChange(data);
    scrollToTop();
  };

  const handleLimitChange = (newLimit) => {
    onLimitChange(newLimit);
    scrollToTop();
  };

  return (
    <div className={styles.pagination}>
      <div className={styles.summary}>
        {start}-{end} из {count}
      </div>
      <ReactPaginate
        pageCount={pageCount}
        forcePage={page}
        onPageChange={handlePageChange}
        containerClassName={styles.container}
        pageClassName={styles.page}
        pageLinkClassName={styles.pageLink}
        activeClassName={styles.active}
        activeLinkClassName={styles.activeLink}
        previousClassName={styles.previous}
        nextClassName={styles.next}
        previousLinkClassName={styles.previousLink}
        nextLinkClassName={styles.nextLink}
        disabledClassName={styles.disabled}
        breakClassName={styles.break}
        breakLinkClassName={styles.breakLink}
        previousLabel="Назад"
        nextLabel="Вперед"
      />
      {onLimitChange ? (
        <div className={styles.limitWrap}>
          <select
            className={styles.limitSelect}
            value={limit}
            onChange={(e) => handleLimitChange(Number(e.target.value))}
            aria-label="Количество на странице"
          >
            {limitOptions.map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}
          </select>
          <span className={styles.limitLabel}>на странице</span>
        </div>
      ) : null}
    </div>
  );
};

export default Pagination;
